import { gql } from "@apollo/client";
import { client } from "graphql/client";
import { ACCOUNTS_PAGE_MODE, AccountsPageMode } from "../../hooks/useAccountDeliveryDriverQuery";

// DSP 入口
export const VIEW_DRIVER_PHONE = gql`
    mutation ViewDriverPhone($accountId: Long!) {
        viewDriverPhone(accountId: $accountId)
    }
`;

// 总部入口：别名保持响应字段名与 DSP 入口一致
export const VIEW_DRIVER_PHONE_FOR_CENTRAL = gql`
    mutation ViewDriverPhoneForCentral($accountId: Long!) {
        viewDriverPhone: viewDriverPhoneForCentral(accountId: $accountId)
    }
`;

// 仓库入口：别名保持响应字段名与 DSP 入口一致
export const VIEW_DRIVER_PHONE_FOR_WMS = gql`
    mutation ViewDriverPhoneForWms($accountId: Long!, $warehouseId: Long!) {
        viewDriverPhone: viewDriverPhoneForWms(accountId: $accountId, warehouseId: $warehouseId)
    }
`;

export interface ViewDriverPhoneResponse {
    viewDriverPhone: string;
}

export interface ViewDriverPhoneVariables {
    accountId: number;
    // 仅仓库入口需要
    warehouseId?: number;
}

export const viewDriverPhone = async (
    accountId: number,
    mode?: AccountsPageMode,
    warehouseId?: number | null
): Promise<string | undefined> => {
    let mutation;
    const variables: ViewDriverPhoneVariables = { accountId };
    if (mode === ACCOUNTS_PAGE_MODE.CENTRAL) {
        mutation = VIEW_DRIVER_PHONE_FOR_CENTRAL;
    } else if (mode === ACCOUNTS_PAGE_MODE.WMS) {
        if (!warehouseId) {
            throw new Error('warehouseId is required in wms mode');
        }
        mutation = VIEW_DRIVER_PHONE_FOR_WMS;
        variables.warehouseId = warehouseId;
    } else if (mode === ACCOUNTS_PAGE_MODE.DSP) {
        mutation = VIEW_DRIVER_PHONE;
    } else {
        // 非三种入口之一时不发请求，不设默认入口
        return undefined;
    }
    const { data } = await client.mutate<ViewDriverPhoneResponse, ViewDriverPhoneVariables>({
        mutation,
        variables
    });
    return data!.viewDriverPhone;
};
